<p-confirmPopup key="confirmPopup"></p-confirmPopup>
<p-confirmDialog [style]="{width: '400px'}" key="confirmDialog" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
